const BLOCKS_ROUTE = '/blocks';

export const BLOCKS_ROUTES = {
  root: BLOCKS_ROUTE,
  // `${BLOCKS_ROUTE}/new` should be added here later
  edit: [`${BLOCKS_ROUTE}/:id`]
};
